// src/components/Home.tsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import CreateJob from './CreateJob';
import JobList from './JobList';
import SendVerificationEmail from './SendVerificationEmail';
import tapirOverview from '../images/TAPIR-website-splash.png';  // Adjust path as needed
import { Link } from 'react-router-dom';


import { Job, Message } from './types'; // adjust path as needed

const Home: React.FC = () => {
    const { userToken, userVerified, userRole, userId } = useAuth();
    const [jobs, setJobs] = useState<Job[]>([]);


    if (!userToken) {
        return <div id="content-pane">
            <div className="overview">
                <div className='splash_box'>TAPIR: a <span className='blue-text'>general model</span> for TCR-target interactivity prediction<span className='blue-text'>.</span></div>
                    <div className="landing_image"><img src={tapirOverview} alt="Over of TAPIR system"/></div>
                    <p>
                        <b>TAPIR</b> is a deep neural network that has been trained to understand the relationships between T-cell receptors (TCRs) and targets across a diverse set of targets and sequence representations.
                        <br></br> 
                        <br></br> 
                        The model accepts <b>any kind of TCR sequence as input</b>, including single chain, paired chain, and sequences with missing gene information, and can predict interactivity with <b>any target</b>, including rare and novel targets such as cancer neoantigens.
                        See <a href="https://www.biorxiv.org/content/10.1101/2023.09.12.557285v1">our paper</a> for more details. TAPIR was also featured in a Nature Reviews Immunology commentary, <a href="https://www.nature.com/articles/s41577-023-00974-7">TCRs and AI: the future is now</a>.  
                    </p>
                    <br></br>
                    <div className='sign_up_hero'>
                        <Link to="signup"><button>Try TAPIR</button></Link>
                    </div>
                </div>
            </div>;
    }

    if (!userVerified) {
        return <div id="content-pane">
                <SendVerificationEmail></SendVerificationEmail>
            </div>;
    }

    if (userRole == "Unapproved") {
        return <div id="content-pane">
                <h3>Please contact us for account verification</h3>
                <p className='approval'>Your email address is not associated with an institution preapproved to try TAPIR. Please contact us at <a href="mailto:contact@vcreate.io">contact@vcreate.io</a> and provide your name and affiliation so that we can manually verify your account.</p>
            </div>;
    }

    return (
        <div>
            <div id="content-pane">
                <CreateJob />
                {userId && <JobList jobs={jobs} setJobs={setJobs} userId={userId} />}
            </div>
        </div>
    );
}

export default Home;
